import {
  colors,
  ImpBulletList,
  ImpContainer,
  ImpText,
} from '@imprint-payments/imprint-ui';

import { useAppSelector } from '../../app/hooks';
import { selectLanguage } from '../../app/languageSelectors';

function DisclosureText({ children }: { children: string }) {
  return (
    <ImpText typography="body3" color={colors.content.onBackgroundVariant}>
      {children}
    </ImpText>
  );
}

export function IncomeDisclosure() {
  const language = useAppSelector(selectLanguage);
  return (
    <ImpContainer>
      <DisclosureText>{language.incomeDisclosureTitle}</DisclosureText>
      <ImpBulletList
        items={language.incomeDisclosureBullets}
        bulletStyle={{
          typography: 'body3',
          color: colors.content.onBackgroundVariant,
        }}
        noGap
      />
    </ImpContainer>
  );
}

export function HousingDisclosure() {
  const language = useAppSelector(selectLanguage);
  return (
    <ImpContainer>
      <DisclosureText>
        {language.monthlyHousingCostDisclosureTitle}
      </DisclosureText>
    </ImpContainer>
  );
}
